import React from "react";
import { components } from "react-select";

const TenureSelectOption = (onDisabledOptionClick) => (props) => {
  const { data, isDisabled } = props;

  if (!isDisabled) {
    return <components.Option {...props} />;
  }

  return (
    <div
      onMouseDown={() => onDisabledOptionClick(data)}
      style={{ cursor: "pointer" }}
    >
      <components.Option {...props} />
    </div>
  );
};

export default TenureSelectOption;
